import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const PaginationTableStyle = {
  boxPagination: () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
  `,
  paginationStyle: css`
    .ant-pagination-next button {
      color: ${theme.colors.lightText};
      background: ${theme.colors.black100} !important;
      border-color: ${theme.borders.tertiary} !important;
      &:hover {
        border-color: ${theme.colors.darkGreen} !important;
      }
    }
    .ant-pagination-prev button {
      color: ${theme.colors.lightText} !important;
      background: ${theme.colors.black100} !important;
      border-color: ${theme.borders.tertiary} !important;
      &:hover {
        border-color: ${theme.colors.darkGreen} !important;
      }
    }
    .ant-pagination-disabled button:disabled {
      color: ${theme.colors.lightText} !important;
      background-color: #363636 !important;
      opacity: 0.8;
    }
    .ant-pagination-item-ellipsis,
    .ant-pagination-item-link-icon {
      color: ${theme.colors.darkGreen} !important;
    }
    .ant-pagination-item-active {
      border-color: ${theme.colors.darkGreen} !important;
      background: ${theme.colors.gradient[1]} !important;

      &:hover {
        background: ${theme.colors.gradient[1]} !important;
        a {
          color: ${theme.colors.text.buttonActive} !important;
        }
      }
    }
    .ant-pagination-item {
      background: ${theme.colors.black100};
      border-color: ${theme.borders.tertiary};
      a {
        color: ${theme.colors.lightText};
      }
    }
    .ant-pagination-item:hover {
      border-color: ${theme.borders.primary};
      background-color: ${theme.colors.black100} !important;
    }
    .ant-pagination-item:hover a {
      color: ${theme.colors.darkGreen};
    }
    .ant-pagination-item-active a {
      color: ${theme.colors.text.buttonActive};
    }
  `,
};
